import { EventEmitter } from '@angular/core';
import { DataService } from './data.service';
import { BusinesLogicService } from './business-logic.service';
import { take } from 'rxjs/operators';
import { NotificationService } from './notification.service';
import { LanguagePipe } from './language.pipe';
import { ModalHelper } from '../components/modal/modal.helper';
var TurnService = (function () {
    function TurnService(_data, _blogic, _notify, _modal, _lang) {
        this._data = _data;
        this._blogic = _blogic;
        this._notify = _notify;
        this._modal = _modal;
        this._lang = _lang;
        this.isCallLoading = new EventEmitter();
        this.autoNotifyInterval = null;
        this.autoSupervisorTimeout = null;
        this.callLoading = false;
    }
    TurnService.prototype.startAutoSupervisor = function () {
        var _this = this;
        clearTimeout(this.autoSupervisorTimeout);
        if (this._data.session['autosupervisor'] && this._data.turn == null) {
            this.autoSupervisorTimeout = setTimeout(function () {
                if (_this._data.inQueue > 0 && !_this._data.deskStopped && !_this._data.pauseModalTurn && !_this._data.redError) {
                    _this.call();
                }
            }, parseInt((this._data.session['autosupervisor_delaytime'])) * 1000);
        }
    };
    TurnService.prototype.stopAutoSupervisor = function () {
        clearTimeout(this.autoSupervisorTimeout);
    };
    TurnService.prototype.enableAutoNotifyInBackground = function () {
        var _this = this;
        clearInterval(this.autoNotifyInterval);
        if (this._data.configuration["autoCheckQueues"]) {
            this.autoNotifyInterval = setInterval(function () {
                if (_this._data.inQueue > 0 && _this._notify.hasPermission() && _this._data.turn == null) {
                    _this._notify.notify(_this._lang.transform("notifyTitle"), _this._lang.transform("notifyBodyInWaitingPart1") + _this._data.inQueue + _this._lang.transform("notifyBodyInWaitingPart2"));
                }
            }, (this._data.configuration["autoCheckQueuesTime"] * 60) * 1000);
        }
    };
    TurnService.prototype.disableAutoNotifyInBackground = function () {
        clearInterval(this.autoNotifyInterval);
    };
    TurnService.prototype.startDeskAutomations = function () {
        this.enableAutoNotifyInBackground();
        this.startAutoSupervisor();
    };
    TurnService.prototype.stopDeskAutomations = function () {
        this.disableAutoNotifyInBackground();
        this.stopAutoSupervisor();
    };
    TurnService.prototype.call = function (id) {
        var _this = this;
        if (id === void 0) { id = null; }
        this.callLoading = true;
        this.isCallLoading.emit(true);
        var params = {
            desk_id: this._data.session["desk"],
            status: "A",
            deskuser: this._data.session["username"],
            deskoperator: this._data.session["operator"],
        };
        this._blogic.deskNotify(params)
            .pipe(take(1))
            .subscribe(function (response) {
            _this._data.actionContainer = 0;
            if (response != null) {
                if (response["turn_id"] == "-1") {
                    _this._data.closeTurn();
                }
                else {
                    _this._data.turn = response;
                    _this._data.lastCalls.unshift(response);
                }
            }
            $("#refreshList").trigger('click');
            _this.callLoading = false;
            _this.isCallLoading.emit(false);
        }, function (error) {
            _this.callLoading = false;
            _this.isCallLoading.emit(false);
        });
    };
    TurnService.prototype.recall = function () {
        var _this = this;
        var actualTurnId = null;
        var params;
        if (this._data.enableRecallSupervisor) {
            actualTurnId = this._data.selectedTurn['id'];
            params = {
                desk_id: this._data.selectedTurn['desk_id'],
                deskuser: this._data.session["username"],
                deskoperator: this._data.session["operator"],
            };
        }
        else {
            actualTurnId = this._data.turn['id'];
            params = {
                desk_id: this._data.session["desk"],
                deskuser: this._data.session["username"],
                deskoperator: this._data.session["operator"]
            };
        }
        this.callLoading = true;
        this.isCallLoading.emit(true);
        this._blogic.recallTurn(params)
            .pipe(take(1))
            .subscribe(function (response) {
            _this._data.actionContainer = 0;
            if ((_this._data.selectedTurn != null && _this._data.selectedTurn['desk']) == _this._data.session['desk']) {
                _this._data.turn = response;
                _this._data.selectedTurn = null;
            }
            var turnsFound = _this._data.turnStatusInViewer.findIndex(function (e) { return e["turn_id"] == actualTurnId; });
            if (turnsFound == -1) {
                _this._data.lastCalls.unshift(response);
            }
            else {
                _this._data.turnStatusInViewer = _this._data.turnStatusInViewer.filter(function (item) { return item["turn_id"] !== actualTurnId; });
            }
            _this.callLoading = false;
            _this.isCallLoading.emit(false);
        }, function (error) {
            _this.callLoading = false;
            _this.isCallLoading.emit(false);
        });
    };
    TurnService.prototype.callList = function () {
        this.callLoading = true;
        this.isCallLoading.emit(true);
        var self = this;
        if (this._data.configuration["activeSupervisor"] && this._data.configuration["questSupervisorDesk"]) {
            $('#desksModal').on('hidden.bs.modal', function () {
                self.callLoading = false;
                self.isCallLoading.emit(false);
            });
            this._modal.show("desksModal");
        }
        else {
            this.actionCallList(this._data.session["desk"]);
        }
    };
    TurnService.prototype.actionCallList = function (desk) {
        var _this = this;
        var params = [];
        if (this._data.configuration["activeSupervisor"]) {
            params = {
                desk_id: desk,
                turn_id: this._data.selectedTurn["id"],
                queue_id: this._data.selectedTurn["queue_id"],
                action: this._data.configuration["actionToCall"],
                deskuser: this._data.session["username"],
                deskoperator: this._data.session["operator"],
            };
        }
        else {
            params = {
                desk_id: desk,
                queue_id: this._data.selectedTurn["queue_id"],
                turn_id: this._data.selectedTurn["id"],
                deskuser: this._data.session["username"],
                deskoperator: this._data.session["operator"]
            };
        }
        this._blogic.setTurn(params)
            .pipe(take(1))
            .subscribe(function (response) {
            _this._data.actionContainer = 0;
            if (response["id"] == "-1") {
                _this._data.closeTurn();
            }
            else {
                if (desk == _this._data.session["desk"]) {
                    _this._data.turn = response;
                    _this._data.lastCalls.unshift(response);
                }
            }
            _this._modal.hide("desksModal");
            _this.callLoading = false;
            _this.isCallLoading.emit(false);
            _this._data.selectedTurn = null;
        });
    };
    return TurnService;
}());
export { TurnService };
